
































import Vue from "vue";
import { useStore } from "@/store/store";
import { MessageDefinedActions, MessageDefinitions, MessageDefinition, MessageTypes, VoidFunction} from "@/types/types";
import { mapStores } from "pinia";
import scssVars from "@/assets/style/_export.module.scss";

export default Vue.extend({
    name: "MessageBanner",

    data: function() {
        return {
            scssVars, // just to be able to use in template
            image: "" as string,
        };
    },

    created() {
        this.image = (this.message.path.length > 0) ? require("@/assets/images/"+this.message.path) : "";
    },
    
    //Updated is needed in case one message pops and before its gone another is shown
    updated() {
        this.image = (this.message.path.length > 0) ? require("@/assets/images/"+this.message.path) : "";
    },

    computed: {
        ...mapStores(useStore),
        
        message(): MessageDefinition {
            return this.appStore.currentMessage;
        },

        showModal(): boolean{
            return this.message.type === MessageTypes.imageDisplay;
        },
    },

    methods: {
        close(): void {
            this.appStore.currentMessage = MessageDefinitions.NoMessage;
        },

        onButtonClick(payload: VoidFunction | string){
            // If the type of the action associated with this button is a function
            // we run this function. If the type is string then we run a predefined action. 
            if((typeof payload) === "function"){
                (payload as VoidFunction)();
            }
            else{
                switch(payload){
                case MessageDefinedActions.closeBanner:
                    this.appStore.currentMessage = MessageDefinitions.NoMessage;
                    break;
                case MessageDefinedActions.undo:
                    this.appStore.applyStateUndoRedoChanges(true);
                    this.appStore.currentMessage = MessageDefinitions.NoMessage;
                    break;
                default:
                    break;
                }
            }
        },
    },
});
